<div class="group-context-menu">
  <div class="group-btn">
    <button class="btn text-secondary btn-icon-only" (click)="contextMenu.contextMenuVisibility($event)">
      <img class="mb-2" alt="logo" src="assets/img/Group.png" />
    </button>
  </div>
  <sysque-context-menu
    #contextMenu
    target="#modus-button"
    (contextMenuItemSelected)="handleContextMenuItem($event)"
    [menuItems]="menuItems"
  ></sysque-context-menu>
</div>
